export function validateNewOrderEmail(newEmail, confirmNewEmail) {
    if (!newEmail && !confirmNewEmail) {
        return 'Both email fields are required.';
    }
    if (!newEmail) {
        return 'The email field is required.';
    }
    if (!confirmNewEmail) {
        return 'The confirm email field is required.';
    }
    if (newEmail !== confirmNewEmail) {
        return 'Email addresses must match.';
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail)) {
        return 'The email address is not valid.';
    }
    return null;
}
